import { render } from "./SorcererView.vue?vue&type=template&id=bced902c&scoped=true"
import script from "./SorcererView.vue?vue&type=script&lang=js"
export * from "./SorcererView.vue?vue&type=script&lang=js"

import "./SorcererView.vue?vue&type=style&index=0&id=bced902c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bced902c"]])

export default __exports__